// display the submenus on the hover of the menu
headerMenus = document.querySelectorAll("header-menu");
headerMenus.forEach(element => {
    element.addEventListener("mouseenter", function(e) {
        console.log("hovered");
        const details = element.querySelector("details");
        const summary = element.querySelector("summary");
         if (details && summary) {
            details.setAttribute("open", ""); // or: details.open = true;
            summary.setAttribute("aria-expanded", "true");
        }
    });

     element.addEventListener("mouseleave", function(e) {
        const details = element.querySelector("details");
        const summary = element.querySelector("summary");
         if (details && summary) {
            details.removeAttribute("open", ""); // or: details.open = true;
            summary.removeAttribute("aria-expanded");
        }
    });
});

